<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    hide-overlay
    fullscreen
    persistent
  >
    <v-card tile>
      <v-card-title class="modal__title px-4 pt-4 pb-4">
        <h3>
          {{ $t(`create.label.${type}`) }}
        </h3>
        <v-spacer />
        <v-btn @click="dialog = false" color="primary" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="dialog" ref="content" class="pt-5 white text-body-1">
        <slot />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CreateRealtyModal',

  props: {
    type: {
      type: String,
      required: true,
    },

    confirmToClose: {
      type: Boolean,
      default: false,
    },

    customCallButton: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    openModal() {
      this.dialog = true
    },

    closeModal() {
      this.dialog = false
    }
  },

  data() {
    return {
      dialog: false,
    }
  },
}
</script>
